<template>
  <div class="page-box ping-box">
    <div class="safe-box">
      <div class="play-area">
        <div
          v-for="item in boxArr"
          :index="item"
          :key="item"
          :class="[
            'piece',
            'piece2-' + item,
            item == boxArractivelass ? 'active' : '',
          ]"
          :style="{ backgroundImage: 'url(' + card[index] + ')' }"
          @click="changePositon($event, item)"
        ></div>
      </div>
    </div>
    <div class="tip-box" v-show="showTip">
      <div class="tip">点击两张碎片进行交换，直到碎片顺序正确即可通关哦</div>
      <div class="know-btn" @click="toStart">开始</div>
    </div>
    <div class="shi-box page-box" v-show="issuccess">
      <div class="safe-box">
        <img
          :src="shi[index].left"
          class="left-img animated hidden"
          id="leftImg"
        />
        <img
          :src="shi[index].right"
          class="right-img animated hidden"
          id="rightImg"
        />
        <div class="btn-box" v-if="showPosterIndex == 1">
          <img src="../assets/btn1.png" class="btn btn1" @click="toPoster" />
          <img src="../assets/btn2.png" class="btn btn2" @click="toIndex" />
        </div>
      </div>
    </div>
    <div class="poster-box" v-if="showPoster">
      <div class="poster-pre-box" ref="posterBox" v-show="showPosterIndex == 1">
        <img :src="posters[index]" class="poster-img animated" id="posterImg" />
        <div class="text-box">
          <div>扫码拼图，解锁景点</div>
          <div>我用时{{ useTime }}秒，快来挑战吧！</div>
        </div>
      </div>
      <div class="success-poster-box" v-show="showPosterIndex == 2">
        <img :src="posterImg" class="posters-img" />
      </div>

      <div class="again-box again-btn"></div>
      <div class="again-box" @click="toIndex"></div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      posters: [
        require("../assets/poster1.jpg"),
        require("../assets/poster2.jpg"),
        require("../assets/poster3.jpg"),
        require("../assets/poster4.jpg"),
        require("../assets/poster5.jpg"),
      ],
      shi: [
        {
          left: require("../assets/shi1_1.png"),
          right: require("../assets/shi1_2.png"),
        },
        {
          left: require("../assets/shi2_1.png"),
          right: require("../assets/shi2_2.png"),
        },
        {
          left: require("../assets/shi3_1.png"),
          right: require("../assets/shi3_2.png"),
        },
        {
          left: require("../assets/shi4_1.png"),
          right: require("../assets/shi4_2.png"),
        },
        {
          left: require("../assets/shi5_1.png"),
          right: require("../assets/shi5_2.png"),
        },
      ],
      card: [
        require("../assets/chart1.png"),
        require("../assets/chart2.png"),
        require("../assets/chart3.png"),
        require("../assets/chart4.png"),
        require("../assets/chart5.png"),
      ],
      posterImg: "", // 生成的海报图片
      scaleByPhone: 1, // 橡树比
      posterBox: null, // 生成的节点
      showPosterIndex: 1, // 1是生成前 2是生成后
      names: ["长江大桥", "黄鹤楼", "三峡人家", "古隆中", "赤壁古战场"],
      boxArractivelass: -1,
      prevIndex: null,
      curIndex: 0,
      useTime: 0,
      showBtn: false,
      boxArr: new Array(4).fill(1).map((item, index) => {
        return index;
      }),
      pieces: document.querySelectorAll(".piece"),
      pool: this.generateMatrix(2, 14.975, 27.857),
      matrixArr: this.upsetArr(this.generateMatrix(2, 14.975, 27.857)),
      wall: 0,
      prevEl: null, // 上一个元素,
      timer: null,
      issuccess: false,
      index: 0,
      showTip: true,
      showPoster: false,
    };
  },
  created() {
    this.index = this.$route.query.index;
  },
  mounted() {
    this.check(this.pool);
    this.initData();
  },
  methods: {
    initData() {
      let that = this;
      that.$nextTick(() => {
        that.scaleByPhone = that.getDpr(); // 像素比
        that.posterBox = this.$refs.posterBox;
        // 监听屏幕变化
      });
    },
    // 获取设备像素比
    getDpr() {
      if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio;
      }
      return 1;
    },
    // 字体做动效
    addAnimate(id, effect, time) {
      clearTimeout(timer);
      let timer = setTimeout(() => {
        let node = document.getElementById(id);
        node.classList.remove("hidden");
        node.classList.add(effect);
      }, time);
    },
    check(pool) {
      this.shuffle(document.querySelectorAll(".piece"), pool);
      if (this.isTestSuccess(pool)) {
        this.check(this.pool);
      }
    },
    toStart() {
      this.showTip = false;
      let that = this;
      this.timer = setInterval(() => {
        that.useTime++;
      }, 1000);
    },
    // 点击高亮并且切换对应位置 (想办法交换对应索引位置的x,y值即可)
    changePositon(e, item) {
      //点击小图片切换位置方法
      let reg = /active/g;
      this.boxArractivelass = item;
      let pieces = document.querySelectorAll(".piece");
      if (!this.wall) {
        this.wall = 1;
        this.prevEl = e.target;
        for (var i = 0, len = pieces.length; i < len; i++) {
          // 使用replace为了避免元素后期加入其他类名
          pieces[i].className = pieces[i].className.replace(" active", "");
        }
        !reg.test(this.className) && (this.className += " active");
      } else {
        this.wall = 0;
        var prevIndex = +this.prevEl.getAttribute("index"),
          curIndex = +e.target.getAttribute("index");
        if (
          this.pool[prevIndex].x == this.pool[curIndex].x ||
          this.pool[prevIndex].y == this.pool[curIndex].y
        ) {
          // 置换数组
          this.swap(this.pool, prevIndex, curIndex);
          this.prevEl.style.transform =
            "translate(" +
            this.pool[prevIndex].x +
            "rem," +
            this.pool[prevIndex].y +
            "rem" +
            ")";
          e.target.style.transform =
            "translate(" +
            this.pool[curIndex].x +
            "rem," +
            this.pool[curIndex].y +
            "rem" +
            ")";
          // 清除样式
          this.boxArractivelass = -1;

          // 校验是否成功
          if (this.isTestSuccess(this.pool)) {
            let that = this;
            // 清除计时器
            clearInterval(this.timer);
            this.issuccess = true;
            this.$toast.success("拼图成功");
            this.addAnimate("leftImg", "fadeIn", 500);
            this.addAnimate("rightImg", "fadeIn", 1500);
            this.showBtn = true;
            // this.showPoster = true;
            // this.addAnimate("posterImg", "fadeIn", 3500);
            // that.getPoster();
            // setTimeout(() => {
            //   that.$toast.success("长按即可保存到手机哦");
            // }, 3500);
          }
        }
      }
    },
    toPoster() {
      let that = this;
      this.showPoster = true;
      that.$toast.loading({
        message: "正在生成...",
        forbidClick: true,
        loadingType: "spinner",
        overlay: true,
      });
      setTimeout(() => {
        that.posterBox = this.$refs.posterBox;
        if (that.posterBox) {
          let W = that.posterBox.offsetWidth;
          let H = that.posterBox.offsetHeight;
          let x = that.posterBox.offsetLeft;
          let y = that.posterBox.offsetTop;
          html2canvas(that.posterBox, {
            useCORS: true, // 开启跨域配置
            allowTaint: true, //允许跨域图片
            taintTest: false, //是否在渲染前测试图片
            scale: that.scaleByPhone,
            x: x,
            y: y,
            scrollX: 0,
            scrolly: 0,
            width: W,
            height: H,
          })
            .then((canvas) => {
              that.showPoster = true;
              that.showPosterIndex = 2;
              that.posterImg = canvas.toDataURL("image/jpg");
              that.$toast.success("长按可保存图片");
              that.iosMusic();
              // alert("成功");
            })
            .catch((canvas) => {
              that.$toast.fail("生成失败，请检查网络");
            });
        } else {
        }
      }, 500);
    },

    iosMusic() {
      var agent = navigator.userAgent.toLowerCase(); //判断手机系统
      // console.log(agent);
      var version;
      if (agent.indexOf("like mac os x") > 0) {
        //ios
        var regStr_saf = /os [\d._]*/gi;
        var verinfo = agent.match(regStr_saf);
        version = (verinfo + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, "."); //获取具体的系统版本号
        console.log(version);
        var typeNum = version.split(".")[0]; //获取系统版本号的第一位数字
        if (typeNum >= 11) {
          wx.ready(function () {
            var globalAudio = document.getElementById("audio");
            globalAudio.pause();
          });
          // document.getElementById("audio").removeAttr("autoplay");
        }
      }
    },
    toIndex() {
      let top = this.$route.query.top;
      this.$router.replace({
        name: "index",
        query: { top: top, index: this.index },
      });
    },
    // 生成n维矩阵
    generateMatrix(n, dx, dy) {
      var arr = [],
        index = 0;
      for (var i = 0; i < n; i++) {
        for (var j = 0; j < n; j++) {
          arr.push({ x: j * dx, y: i * dy, index: index });
          index++;
        }
      }
      return arr;
    },

    shuffle(els, arr) {
      this.upsetArr(arr);
      for (var i = 0, len = els.length; i < len; i++) {
        var el = els[i];
        el.setAttribute("index", i); // 将打乱后的数组索引缓存到元素中
        el.style.transform =
          "translate(" + arr[i].x + "rem," + arr[i].y + "rem" + ")";
      }
    },
    upsetArr(arr) {
      // 方法1:
      return arr.sort(function () {
        return Math.random() > 0.5 ? -1 : 1;
      });
    },
    // 置换数组(对应索引的x,y值进行交换)
    swap(arr, indexA, indexB) {
      // ES6的解耦交换方式： [arr[index], arr[n]] = [arr[n], arr[index]];
      [arr[indexA], arr[indexB]] = [arr[indexB], arr[indexA]];
    },

    // 校验是否成功方法
    isTestSuccess(arr) {
      return arr.every(function (item, i) {
        return item.index === i;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ping-box {
  width: 100vw;
  height: 100vh;
  background: url("../assets/ping_bg.jpg") no-repeat center;
  background-size: 100% auto;
}
.play-area {
  position: relative;
  width: 29.95rem;
  height: 55.75rem;
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  top: 2.35rem;
  left: 3.975rem;
  .piece {
    position: absolute;
    left: 0;
    top: 0;
    width: 14.975rem;
    height: 27.857rem;
    border: 1px solid transparent;
    background-repeat: no-repeat;
    background-size: 29.95rem 55.75rem;
    transition: transform 0.6s ease-in-out;
    box-sizing: border-box;
  }
  .piece.active {
    border: 2px solid red;
  }
  .piece2-0 {
    background-position: 0 0;
  }
  .piece2-1 {
    background-position: -14.975rem 0;
  }
  .piece2-2 {
    background-position: 0 -27.857rem;
  }
  .piece2-3 {
    background-position: -14.975rem -27.857rem;
  }
}
.play-area.active {
  outline-color: #1f8b40;
}
.tip-box {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  font-size: 1.8rem;
  line-height: 3rem;
  .tip {
    width: 28rem;
    border: 1px solid #fff;
    border-radius: 1rem;
    padding: 3rem 2rem;
    box-sizing: border-box;
    margin: 15rem auto;
    text-align: center;
    background: #fff;
  }
  .know-btn {
    width: 16rem;
    height: 3rem;
    background: #fff;
    color: #000;
    text-align: center;
    border-radius: 3rem;
    margin: 0 auto;
  }
}
.shi-box {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: fixed;
  left: 0;
  top: 0;
  .left-img {
    width: 40vw;
    height: 48.24rem;
    position: absolute;
    top: 0rem;
    left: 5vw;
  }
  .right-img {
    width: 40vw;
    height: 48.24rem;
    position: absolute;
    top: 0rem;
    right: 5vw;
  }
  .btn-box {
    width: 100vw;
    position: absolute;
    top: 45rem;
    .btn {
      width: 17rem;
      display: block;
      margin: 1rem auto;
    }
  }
}
.poster-box {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  position: fixed;
  top: 0;
  left: 0;
  .poster-pre-box {
    width: 100vw;
    height: 75.7rem;
    position: relative;
    .poster-img {
      width: 100vw;
      height: 75.7rem;
    }
    .text-box {
      width: 100vw;
      position: absolute;
      text-align: center;
      left: 0;
      top: 68.5rem;
      color: #fff;
      line-height: 3.4rem;
      font-size: 2.7rem;
      font-weight: bold;
    }
  }
  .success-poster-box {
    width: 100vw;
    height: 100vh;
    background: #916c4f;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    z-index: 99999;
    .posters-img {
      width: auto;
      height: auto;
      max-width: 95%;
      max-height: 90%;
      z-index: 11111111;
    }
  }
  .again-box {
    width: 17rem;
    height: 4.8rem;
    position: fixed;
    bottom: 0rem;
    left: 10.25rem;
  }

  .again-btn {
    background: url("../assets/btn2.png") no-repeat center;
    background-size: 100%;
    pointer-events: none; // 禁止none ，启用auto
    z-index: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Ping.vue